import {
  Box,
  Button,
  Icon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import { Card } from '@ui/components/Card';
import DesktopBg from '@ui/components/DesktopBg';
import TransactionHistoryContent from '@ui/components/TransactionHistoryDrawer/TransactionHistoryContent';
import UpdateBanners from '@ui/components/UpdateBanner/UpdateBanners';
import WithWallet from '@ui/components/Wallet/WithWallet';
import { useNonNegativeInteger } from '@ui/hooks/numbers';
import { useRealPathname } from '@ui/hooks/router';
import { CoinModeProvider } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';
import { PRELAUNCH } from '@ui/utils/constants';
import { pushRouterWithoutRerender } from '@ui/utils/urlHistory';
import { ArrowBack } from '@veno-app/icons';
import { currentWallet } from '@veno-app/wallet';
import { useRef, useState } from 'react';

import { modes } from './DashboardMobile';
import Staking from './Staking';
import { Vaults } from './Vaults';

const { useIsConnected } = currentWallet;

export const DashboardDesktop = () => {
  const t = useTranslations();
  const historyContentIdRef = useRef(String(Math.random()));
  const connected = useIsConnected();
  const realPathname = useRealPathname();
  const [showTransactionHistory, setShowTransactionHistory] = useState(false);
  const tabIndex = useNonNegativeInteger(
    modes.findIndex((v) => v.routePath === realPathname),
  );

  return (
    <>
      <DesktopBg pattern={connected ? 'PATTERN_4' : 'PATTERN_4_SMALL'} />
      <UpdateBanners w="678px" />
      <WithWallet
        mt={6}
        connectHint={t('Connect wallet to see your dashboard')}
      >
        <Text as="h1" textStyle="h1" fontWeight="normal" textAlign="center">
          {t('Dashboard')}
        </Text>
        <Card w="564px" mx="auto" px={8} mt={8} pt={8}>
          {!showTransactionHistory && (
            <Tabs
              index={tabIndex}
              onChange={(index) => {
                const mode = modes[index];
                pushRouterWithoutRerender(mode.routePath);
              }}
              isLazy={true}
            >
              <TabList>
                {modes.map((v) => {
                  return (
                    <Tab
                      key={v.mode}
                      isDisabled={PRELAUNCH && v.mode === 'vno'}
                    >
                      {v.text}
                    </Tab>
                  );
                })}
              </TabList>
              <TabPanels>
                {modes.map((mode, i) => {
                  let child = null;
                  if (mode)
                    if (mode.mode === 'cro' || mode.mode === 'atom') {
                      child = (
                        <CoinModeProvider value={mode.mode}>
                          <Staking
                            coinMode={mode.mode}
                            showTransactionHistory={() =>
                              setShowTransactionHistory(true)
                            }
                          />
                        </CoinModeProvider>
                      );
                    } else if (mode.mode === 'vno') {
                      child = <Vaults />;
                    }
                  return <TabPanel key={i}>{child}</TabPanel>;
                })}
              </TabPanels>
            </Tabs>
          )}
          {showTransactionHistory && (
            <Box w="full" pb="40px">
              <Button
                mb={10}
                variant="raised"
                onClick={() => setShowTransactionHistory(false)}
              >
                <Icon as={ArrowBack} />
              </Button>
              <Text textStyle="h3" mb={8}>
                Transaction history
              </Text>
              <TransactionHistoryContent
                isOpen={showTransactionHistory}
                idRef={historyContentIdRef}
                expandHistoryInfo={true}
              />
            </Box>
          )}
        </Card>
      </WithWallet>
    </>
  );
};
